import i18n from "i18next";
import {initReactI18next} from "react-i18next";
import af from "./af.js";
import en from "./en.js";

const DEFAULT_LANG = "en";
const FALLBACK_LANG = "af";

i18n.use(initReactI18next).init({
  debug: false,
  lng: DEFAULT_LANG,
  fallbackLng: FALLBACK_LANG,
  returnObject: true,
  interpolation: {escapeValue: false},
  resources: {
    en: {translation: en},
    af: {translation: af},
  },
  detection: {
    order: ["navigator"],
  },
});

export default i18n;
